'use strict'

function getQueryString(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return decodeURI(r[2])
  }
}
function getUrlParameter(name) {
  name = name
    .replace(/[]/, '[')
    .replace(/[]/, '[')
    .replace(/[]/, '\\]')
  var regexS = '[\\?&]' + name + '=([^&#]*)'
  var regex = new RegExp(regexS)
  var results = regex.exec(window.parent.location.href)
  if (results == null) return ''
  else {
    return results[1]
  }
}
function getBaseApi() {
  let baseApi = ''
  if (
    window.location.href.includes('mambike') ||
    window.location.href.includes('mamobility')
  ) {
    let unitype = getUrlParameter('unitype')
    switch (unitype) {
      case '1':
        baseApi = 'http://118.31.117.243/auth/api'
        break
      case '2':
        baseApi = 'https://test-dsp.mamcharge.com/auth/api'
        break
      case '3':
        baseApi = 'https://dsp.mamcharge.com/auth/api'
        break
      default:
        baseApi = 'http://118.31.117.243/auth/api'
        break
    }
  } else {
    baseApi = `${getCookie('app.domain')}/auth/api`
  }
  return baseApi
}

/**
 *
 * @param {String} name 获取cookie
 */
function getCookie(name) {
  var arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')

  if ((arr = document.cookie.match(reg))) return unescape(arr[2])
  else return null
}

//xhr 封装
function ajax(options) {
  var url = options.url
  var type = options.type || 'GET'
  var dataType = options.dataType || 'json'
  var onsuccess = options.success || function() {}
  var onerror = options.error || function() {}
  var data = options.data

  var dataStr = []
  for (var key in data) {
    dataStr.push(key + '=' + data[key])
  }
  dataStr = dataStr.join('&')

  if (type === 'GET') {
    url += '?' + dataStr
  }

  var xhr = new XMLHttpRequest()

  xhr.open(type, url, false)
  if (type === 'POST') {
    xhr.setRequestHeader('Content-type', 'application/json')
  }
  xhr.onload = function() {
    if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
      if (dataType === 'json') {
        let res = JSON.parse(xhr.responseText)
        if (res.errcode !== 0) {
          console.log(res.errmsg)
          onerror()
        } else {
          console.log('单点登录token', res)
          onsuccess(JSON.parse(xhr.responseText))
        }
      } else {
        onsuccess(xhr.responseText)
      }
    } else {
      onerror()
    }
  }
  xhr.onerror = onerror
  if (type === 'POST') {
    xhr.send(JSON.stringify(data))
  } else {
    xhr.send()
  }
}
class SSO {
  constructor() {}

  init(callback, errorCallBack) {
    console.log('%c%s', 'color:red', '单点登录的init方法')
    if (
      getUrlParameter('code') != undefined &&
      getUrlParameter('code') != '' &&
      getUrlParameter('code') != null
    ) {
      let code = getUrlParameter('code')
      let baseApi = getBaseApi()
      ajax({
        url: `${baseApi}/api/common/token`,
        data: { code: code },
        success(res) {
          callback(res)
        }
      })
    } else {
      errorCallBack &&
        errorCallBack({
          code: 1,
          message: 'token获取失败',
          data: false
        })
    }
  }
}

// 兼容CommonJs规范
if (typeof module !== 'undefined' && module.exports) module.exports = new SSO()

// 兼容AMD/CMD规范
if (typeof define === 'function') {
  define(function() {
    return new SSO()
  })
}

module.exports = new SSO()



//////////////////
// WEBPACK FOOTER
// ./~/mam-sso/sso.js
// module id = 1587
// module chunks = 0